import angular from "angular";
import core from "../../core/core.module";
import mobiusHandler from "../mobius-handler";

angular
    .module('mobiusControl.handlerForm', [core, mobiusHandler])
    .component('handlerForm', {
        controller: ['notifier', 'MobiusHandler', controller],
        template: require('./handler-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(notifier, MobiusHandler) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.requests = $ctrl.resolve.requests;
        $ctrl.errorTypes = $ctrl.resolve.errorTypes;

        $ctrl.id = null;
        $ctrl.errorType = null;
        $ctrl.errorCode = null;
        $ctrl.errorMessage = null;
        $ctrl.requestSlug = null;
        $ctrl.message = null;

        if ($ctrl.resolve.handler) {
            $ctrl.id = $ctrl.resolve.handler.id;
            $ctrl.errorType = $ctrl.resolve.handler.errorType;
            $ctrl.errorCode = $ctrl.resolve.handler.errorCode;
            $ctrl.errorMessage = $ctrl.resolve.handler.errorMessage;
            $ctrl.requestSlug = $ctrl.resolve.handler.requestSlug;
            $ctrl.message = $ctrl.resolve.handler.message;
        }

    };

    $ctrl.submit = function () {

        let params = {
            errorType: $ctrl.errorType,
            errorCode: $ctrl.errorCode,
            errorMessage: $ctrl.errorMessage,
            requestSlug: $ctrl.requestSlug,
            message: $ctrl.message,
        };

        $ctrl.loading = true;

        let defer = $ctrl.id ? MobiusHandler.update($ctrl.id, params) : MobiusHandler.store(params);

        defer.then(
            function (response) {
                $ctrl.loading = false;
                if ($ctrl.id) {
                    notifier.successNotify('Данные успешно обновились');
                } else {
                    notifier.successNotify('Данные успешно сохранились');
                    params.id = response.data.id;
                }
                $ctrl.close({$value: params});
            },
            function (error) {
                $ctrl.loading = false;
                notifier.errorResponseNotify(error);
            }
        );
    };

}

export default 'mobiusControl.handlerForm';



// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/handler-form/handler-form.js